export const CONTACT_PAGE = "Contact";
export const HCP_PAGE = "Providers";
export const HOME = "Home";
export const INSIGHTS = "News & Insights";
export const PATIENTS_PAGE = "Patients";
export const LIFE_SCIENCES_PAGE = "Pharma";
export const COMPANY_PAGE = "Company";
export const FIELD_PAGE = "Field"; // Page created for xifaxan
export const OUR_SOLUTIONS = "Our Solution";

export const PAGES_TITLE = {
    DEMO : "Demo Page",
    INSIGHTS_CASE_STUDIES: "/insights/case-studies/",
}

export const PAGE_WITHOUT_HEADER_FOOTER:string[] = [
    PAGES_TITLE.DEMO
]

